<div
  class="flex items-center w-full gap-5 px-10 text-white bg-top bg-scores h-238 rounded-10 max-sm:rounded-5 max-sm:h-81 max-sm:px-3 max-sm:gap-3"
>
  <div
    class="w-[150px] h-[150px] p-4 max-sm:p-2 max-sm:w-[57px] max-sm:h-[57px] bg-white rounded-full flex justify-center items-center"
  >
    <img
      alt="competitionLogo"
      class="w-[105px] h-[105px] max-sm:w-[40px] max-sm:h-[40px] object-contain"
      [src]="this.getCompetitionLogo()"
    />
  </div>

  <div class="font-inter-600">
    <div class="flex items-center">
      <h1 class="mr-2 text-white text-32 max-sm:text-14">
        {{ this.getCompetitionName() }}
      </h1>

      <img
        alt="favorite"
        class="cursor-pointer max-sm:w-[15px]"
        [src]="
          urlSVG +
          (this.isFavoriteCompetition() ? 'fav-red.svg' : 'fav-outlined.svg')
        "
        (click)="$event.stopPropagation(); toogleFavoriteCompetition()"
      />
    </div>

    @if(this.getCompetitionSeason()) {
    <span class="flex items-center gap-2 text-16 max-sm:text-11">
      <img
        alt="calendar"
        class="max-sm:w-[12px]"
        [src]="urlSVG + 'calendar-white.svg'"
      />
      {{ this.getCompetitionSeason() }}
    </span>
    }
  </div>
</div>
